<template>
  <div class="root">
    <!-- TODO Handle error status -->
    <template v-if="apiStatus === 1">
      <linear-loader class="container" text="Fetching product" />
    </template>
    <template v-else-if="apiStatus === 2">
      <div class="row hcenter details container">
        <div class="product-image">
          <div class="img">
            <img :src="getProductImage(product)" :alt="product.name" />
            <product-stock-display :product="product" />
          </div>
        </div>
        <div class="product-details">
          <div class="content">
            <h2 class="mt-0 mb-0">{{ product.name }}</h2>
            <h2 class="mt-0">$ {{ product.price }}</h2>
            <p>
              {{ product.description }}
            </p>
            <product-stock-display :product="product" :open="true" />

            <div class="divider"></div>
            <quantity-select
              v-if="cartItem"
              class="actions"
              :cartItem="cartItem"
            />

            <button
              v-else
              class="waves"
              :class="{
                loading: addtoCartApiStatus === 1,
                disabled: product.stock <= 0,
              }"
              :disabled="product.stock <= 0"
              @click.stop="addToCart(product)"
            >
              add to cart
            </button>
          </div>
        </div>
      </div>

      <div class="related-products-container">
        <h2 class="mb-2">You may also like...</h2>
        <div class="related-products">
          <product-card
            class="product-card"
            v-for="(rProduct, index) in relatedProducts"
            :key="`product-${index}`"
            :product="rProduct"
          />
          <!-- for the right spacing -->
          <div class="dummy"></div>
        </div>
      </div>

      <cart-button />
    </template>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters } from "vuex";

import { getProductPrimaryImage } from "@/utils";
import { AppConfig } from "@/utils/variables";

import ProductStockDisplay from "@/components/product/ProductStockDisplay";
import ProductCard from "@/components/product/ProductCard";
import LinearLoader from "@/components/loaders/LinearLoader";
import CartButton from "@/components/product/CartButton";
import QuantitySelect from "../cart/components/QuantitySelect";

export default {
  name: "ProductDetails",
  components: {
    LinearLoader,
    CartButton,
    ProductCard,
    QuantitySelect,
    ProductStockDisplay,
  },
  computed: {
    ...mapGetters({
      product: "Products/getProduct",
      apiStatus: "Products/getProductApiStatus",

      products: "Products/getAll",

      cart: "Cart/cart",
      addtoCartApiStatus: "Cart/addCartItemStatus",
    }),
    cartItem() {
      document.title = `${this.product.name} | ${AppConfig.name}`;
      return this.cart.find((item) => item.product.id === this.product.id);
    },
    relatedProducts() {
      return this.products.filter(
        (product) =>
          product.category.name === this.product.category.name &&
          product.id !== this.product.id
      );
    },
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    },
  },
  mounted() {
    T.waves();
  },
  methods: {
    init() {
      this.$store.dispatch("Products/getProductById", this.$route.params.id);

      // TODO fetch products by this product's category instead
      this.$store.dispatch("Products/getAll");
    },
    addToCart(product) {
      let foundItem = this.cart.find(
        (cartItem) => product.id === cartItem.product.id
      );

      if (foundItem) {
        if (foundItem.quantity >= product.stock) {
          // TODO: notify user that they have added all available productt 'x'
        } else {
          this.performAddToCart(product);
        }
      } else {
        this.performAddToCart(product);
      }
    },
    performAddToCart(product) {
      this.$store.dispatch("Cart/addCartItem", product).then(() => {
        if (this.addCartItemStatus === 2) {
          // TODO: notify the user of success
          console.log(`${product.name} Added to cart successfully!`);
        } else if (this.addCartItemStatus === 3) {
          // TODO: notify the user of the error
          console.log("Could not add item to cart!", this.addCartItemMessage);
        }
      });
    },

    getProductImage(product) {
      return getProductPrimaryImage(product);
    },
  },
};
</script>

<style lang="scss" scoped>
.details {
  .product-image {
    width: 100%;
    display: flex;
    padding: 1.5rem;
    justify-content: center;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background: linear-gradient(150deg, #ffffffda, #00000015);

    .img {
      width: 100%;
      position: relative;
      max-height: 300px;
      min-height: 200px;
      border-radius: 10px;
      box-shadow: 0 10px 20px 5px #00000025;

      img {
        border-radius: inherit;
      }
    }
  }

  .product-details {
    width: 100%;

    .content {
      padding: 1rem;
      background-color: #ffffff50;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      box-shadow: 2px 3px 10px 2px #00000005;
      backdrop-filter: blur(20px);

      .divider {
        margin: 0.75rem 0 1rem;
      }
    }
  }

  @include tablet-and-up {
    .product-image,
    .product-details {
      padding: 2rem 0;
    }

    .product-image {
      width: 30%;
      min-width: 300px;
      border-radius: 10px;

      .img {
        min-width: 60%;
        max-width: 80%;
      }
    }

    .product-details {
      width: 400px;
      margin-left: -1.5rem;

      .content {
        border-radius: 10px;

        .actions {
          width: 60%;
          margin: 0 auto;
        }
      }
    }
  }
}

$padding-value: 5%;
.related-products-container {
  margin: 2rem 0 3rem;

  h2 {
    margin-left: $padding-value;
  }

  .related-products {
    display: flex;
    overflow: auto;
    padding: 0 $padding-value;

    .product-card {
      width: 200px;
      flex-shrink: 0;
      margin-right: 1rem;

      // &:first-child {
      //   margin-left: $padding-value;
      // }

      &:nth-last-child(2) {
        margin-right: 0;
      }
    }

    .dummy {
      flex-shrink: 0;
      width: $padding-value;
      visibility: hidden;
    }
  }

  @include laptop-and-up {
    padding: 0 $padding-value;

    h2 {
      margin-left: initial;
    }

    .related-products {
      padding: 0 5px;

      .dummy {
        width: 5px;
      }
    }
  }
}
</style>

<style lang="scss">
.theme-dark {
  .product-image {
    background: linear-gradient(150deg, #000000da, #ffffff15) !important;
  }

  .product-details .content {
    background-color: $dark-light-color !important;
    box-shadow: 2px 3px 10px 2px #ffffff05 !important;
  }
}
</style>
